import React, { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode; title?: string };

type State = { hasError: boolean; message: string | null };

/**
 * Stops a single report subsection from unmounting the entire Reports page on throw (e.g. chart lib edge cases).
 */
export default class ReportErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: null };

  static getDerivedStateFromError(err: Error): State {
    return { hasError: true, message: err?.message ?? 'Unknown error' };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ReportErrorBoundary:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="rounded-lg border border-amber-200 bg-amber-50/90 p-4 text-sm text-amber-900">
          <p className="font-semibold">{this.props.title ?? 'This section'} could not be displayed</p>
          <p className="mt-1 text-amber-800/90 break-words">{this.state.message}</p>
          <button
            type="button"
            className="mt-3 rounded-md border border-amber-300 bg-white px-3 py-1.5 text-xs font-medium text-amber-900 hover:bg-amber-100"
            onClick={() => this.setState({ hasError: false, message: null })}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
